import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.css';
import './App.css';
import PaymentMethodCheckout from './pages/paymentMethodCheckout';
import DirectPaymentCheckout from './pages/directPaymentCheckout';
import HostedPaymentCheckout from './pages/hostedPaymentCheckout';
import LiveLinkCheckout from './pages/LiveLinkCheckout';
import SuccessfulPaymentView from './pages/paymentLink/postPaymentView/successfulPaymentView';
import FailedPaymnetView from './pages/paymentLink/postPaymentView/failedPaymentView';
import PaymobTransactionCallback from './pages/paymobTransactionCallback';
import PaymentLinkView from './pages/paymentLink/paymentLinkView';

class App extends React.Component {
  render() {
    return (
      <Router>
        <Routes>
          <Route exact path='/hosted/payment' element={<HostedPaymentCheckout />} />
          <Route exact path='/direct/payment' element={<DirectPaymentCheckout />} />
          <Route exact path='/method' element={<PaymentMethodCheckout />} />
          <Route exact path='/live/*' element={<LiveLinkCheckout />} />
          <Route exact path='/payment/success' element={<SuccessfulPaymentView />} />
          <Route exact path='/payment/failure' element={<FailedPaymnetView />} />
          <Route exact path='/transaction/paymob/callback' element={<PaymobTransactionCallback />} />
          <Route exact path='liveV2/*' element={<PaymentLinkView/>} />
        </Routes>
      </Router>);
  }
}

export default App;
